











































import { defineComponent, PropType } from "@vue/composition-api";
import { MediaConstraints } from "@/types";
import BaseButton from "@/components/BaseButton";
import BaseIcon from "@/components/BaseIcon";
import MobileSwitchCam from "@/components/MobileSwitchCam";
import Share from "@/components/Share";
import SwitchMicrophone from "@/components/SwitchMicrophone";
import PrivateInvitationController from "../PrivateInvitationController";
import ToggleCam from "../ToggleCam";

export default defineComponent({
  name: "ControlButtons",
  components: {
    ToggleCam,
    BaseButton,
    BaseIcon,
    PrivateInvitationController,
    SwitchMicrophone,
    MobileSwitchCam,
    Share,
  },
  props: {
    showShare: { type: Boolean, default: false },
    produce: { type: Boolean, required: true },
    canProduce: { type: Boolean, required: true },
    stream: { type: MediaStream, required: true },
    constraints: { type: Object as PropType<MediaConstraints> },
    privateLivesAvailable: { type: Boolean, required: true },
    privateLivePrice: { type: Number, default: 0 },
    privateButtonDisabled: { type: Boolean, default: false },
  },
});
